import { render, staticRenderFns } from "./DigitalGuardianFAQ.vue?vue&type=template&id=1b4efef4&scoped=true&"
import script from "./DigitalGuardianFAQ.vue?vue&type=script&lang=js&"
export * from "./DigitalGuardianFAQ.vue?vue&type=script&lang=js&"
import style0 from "./DigitalGuardianFAQ.vue?vue&type=style&index=0&id=1b4efef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4efef4",
  null
  
)

export default component.exports